// extracted by mini-css-extract-plugin
module.exports = {"price":"SwapMultipleForm_price__39y58"};